<template>
    <form
        id="EducationForm"
        class="flex flex-col gap-4 h-48"
        @submit.prevent="form.post(action)"
    >
        <SelectField
            v-model="form.highest_degree"
            name="highest_degree"
            :label="$t('home.onboarding.fields.highest_degree')"
            :error="translateMaybe(form.errors.highest_degree)"
            :options="OPTIONS.HIGHEST_DEGREE"
            setup
            custom-placeholder-class="text-gray-700"
        />
        <transition
            enter-active-class="transition duration-300 ease-out"
            enter-from-class="translate-y-1 opacity-0"
            enter-to-class="translate-y-0 opacity-100"
            leave-active-class="transition duration-150 ease-in"
            leave-from-class="translate-y-0 opacity-100"
            leave-to-class="translate-y-1 opacity-0"
        >
            <SelectField
                v-if="hasTitle"
                v-model="form.title"
                name="title"
                :options="OPTIONS.TITLES"
                :label="$t('home.onboarding.fields.title')"
                :error="translateMaybe(form.errors.title)"
                setup
                custom-placeholder-class="text-gray-700"
            />
        </transition>
    </form>
</template>

<script setup>
import SelectField from "@/Components/FormFields/SelectField.vue";
import { OPTIONS } from "@/Helpers/constants.js";
import { translateMaybe } from "@/Helpers/translateMaybe.js";
import { useForm } from "@inertiajs/vue3";
import { computed, watch, watchEffect } from "vue";

const props = defineProps({
    action: {
        type: String,
        default: null,
    },
    highestDegree: {
        type: Number,
        default: null,
    },
    title: {
        type: Number,
        default: null,
    },
    form: {
        type: Object,
        default: null,
    },
});

const emit = defineEmits(["form-complete"]);

const form =
    props.form ??
    useForm({
        highest_degree: props.highestDegree,
        title: props.title ?? OPTIONS.TITLES[0].value,
    });

const hasTitle = computed(
    () =>
        form?.highest_degree ===
        OPTIONS.HIGHEST_DEGREE[OPTIONS.HIGHEST_DEGREE.length - 1].value
);

watch(hasTitle, (newValue) => {
    if (!newValue) {
        form.reset("title");
    }
    form.title = OPTIONS.TITLES[0].value;
});

watchEffect(() => {
    emit("form-complete", Boolean(form.highest_degree));
});
</script>
